import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { chatKeyboardFocusVisible } from '../../styles/chatFocus';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};
  align-items: flex-start;
  padding: ${toRem(16)};
  background: ${baseVariables.color['base20']};
  border-radius: ${toRem(14)};
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
`;

export const MobileDrawer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${baseVariables.color['base20']};
  z-index: 1003;
  display: flex;
  flex-direction: column;
  animation: slideInRight 0.3s ease-out;
  width: 90%;

  @keyframes slideInRight {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`;

export const MobileHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${toRem(16)} ${toRem(20)};
  height: ${toRem(56)};
`;

export const MobileHeaderLeft = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${toRem(24)};
  height: ${toRem(24)};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #1c1c1c;

  ${chatKeyboardFocusVisible}
`;

export const MobileHeaderTitle = styled.h2`
  font-family: ${baseVariables.font.fontFamilySwiss};
  font-weight: 500;
  font-size: ${toRem(16)};
  line-height: 1.25;
  color: #1c1c1c;
  margin: 0;
  flex: 1;
  text-align: center;
`;

export const MobileHeaderRight = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: ${toRem(4)};
  color: #1c1c1c;
  border-radius: ${toRem(4)};
  background: var(--t-icon-btn-primary-bg-color, #eeeeee);

  ${chatKeyboardFocusVisible}
`;

export const MobileContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${toRem(16)} ${toRem(20)};
`;

export const MobileNavList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};
`;

export const MobileNavItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${toRem(8)} 0;
  text-decoration: none;
  cursor: pointer;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  font-family: inherit;
  color: #1c1c1c;

  &:last-child {
    border-bottom: none;
  }

  ${chatKeyboardFocusVisible}
`;

export const MobileNavItemLabel = styled.span`
  font-family: ${baseVariables.font.fontFamilySwiss};
  font-weight: 400;
  font-size: ${toRem(16)};
  line-height: 1.5;
  color: #1c1c1c;
`;

export const MobileNavItemIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1c1c1c;
`;

export const WrapperCompact = styled(Wrapper)`
  padding: ${toRem(8)} ${toRem(16)};
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  padding-bottom: ${toRem(4)};
  width: 100%;
  gap: ${toRem(8)};
`;

export const HeaderTitle = styled.div`
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: ${baseVariables.font.fontFamilySwiss};
  font-weight: 500;
  font-size: ${toRem(16)};
  line-height: 1.25;
  color: var(--color-set-brand-fg-color, #1c1c1c);
`;

export const NavList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const NavItem = styled.a<{ $isActive?: boolean }>`
  display: flex;
  gap: ${toRem(16)};
  height: ${toRem(32)};
  align-items: center;
  padding: ${toRem(4)} 0;
  border-radius: ${toRem(4)};
  width: 100%;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  background: none;
  border: none;
  text-align: left;
  font-family: inherit;

  ${({ $isActive }) =>
    $isActive &&
    `
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: ${toRem(-8)};
      right: ${toRem(-8)};
      height: ${toRem(29)};
      background: rgba(28, 28, 28, 0.04);
      border-radius: ${toRem(8)};
      z-index: 0;
    }
  `}

  &:hover {
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: ${toRem(-8)};
      right: ${toRem(-8)};
      height: ${toRem(29)};
      background: rgba(28, 28, 28, 0.04);
      border-radius: ${toRem(8)};
      z-index: 0;
    }
  }

  ${chatKeyboardFocusVisible}
`;

export const NavItemLabel = styled.span`
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: ${baseVariables.font.fontFamilySwiss};
  font-weight: 400;
  font-size: ${toRem(14)};
  line-height: 1.5;
  color: var(--color-set-brand-fg-color, #1c1c1c);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  z-index: 1;
`;

export const NavItemIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
`;

export const SettingsOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1002;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;

  @media ${baseVariables.mediaQuery.md} {
    align-items: flex-end;
    justify-content: flex-start;
    padding: ${toRem(24)};
    padding-left: ${toRem(32)};
    padding-bottom: ${toRem(56)};
  }
`;

export const SettingsPanelContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${toRem(4)};
  animation: slideUp 0.2s ease-out;

  @media ${baseVariables.mediaQuery.md} {
    max-width: ${toRem(600)};
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  > ${Wrapper} {
    flex: 0 0 ${toRem(168)};
    max-width: ${toRem(280)};
    height: max-content;
  }
`;

export const SettingsPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(16)};
  max-width: ${toRem(280)};
  width: 100%;
  animation: slideUp 0.2s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
